//
//
//
//
//
//
//
//
//
//

import AppDetail from './Detail.vue'
import TransitionToggle from '../transitions/Toggle.vue'
import { mapGetters } from 'vuex'
export default {
  name: "AppDetails",
  components: {
    AppDetail,
    TransitionToggle
  },
  props: [
    'spec',
    'label'
  ],
  computed: {
    ...mapGetters(['products']),
  }
}
